var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLogoDropDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      filter: "invert(0)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 144)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4744",
    "data-name": "Mask Group 4744",
    transform: "translate(-19 -144)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pre-order",
    transform: "translate(1.833 123.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7318",
    "data-name": "Path 7318",
    d: "M136.265,26.215a4.661,4.661,0,1,1,8.792,0",
    transform: "translate(-111.494 3)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7319",
    "data-name": "Path 7319",
    d: "M256,100v1.554h1.554",
    transform: "translate(-226.833 -73.893)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7315",
    "data-name": "Path 7315",
    d: "M112.119,343.107v1.243a1.554,1.554,0,0,1-1.554,1.554h-9.011A1.554,1.554,0,0,1,100,344.35V340",
    transform: "translate(-76.893 -305.165)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7316",
    "data-name": "Path 7316",
    d: "M216,261.554a1.554,1.554,0,1,1,3.107,0,1.554,1.554,0,0,0,1.554,1.554h6.059v-1.554A1.554,1.554,0,0,0,225.167,260h-7.613",
    transform: "translate(-188.387 -228.272)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "#0a64f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7317",
    "data-name": "Path 7317",
    d: "M30.72,261.554a1.554,1.554,0,1,0-3.107,0,1.554,1.554,0,0,1-1.554,1.554H20v-1.554A1.554,1.554,0,0,1,21.554,260h7.613",
    transform: "translate(0 -228.272)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "#0a64f9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoDropDown);
export default __webpack_public_path__ + "static/media/userLogoDropDown.d704a109c50f0f8e39ad3e6c6ffde1b8.svg";
export { ForwardRef as ReactComponent };